// mm-bundle-drawer.js — /pages/bundle: intercepte la redirection /cart du box builder
// Rapi (XHR /cart/add.js puis location.href="/cart" en dur) et ouvre le cart drawer du
// theme a la place. Navigateurs sans Navigation API: comportement d'origine.
(function () {
  var armed = 0;
  var oOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__mmCartAdd = /\/cart\/add/.test(String(u));
    return oOpen.apply(this, arguments);
  };
  var oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__mmCartAdd) this.addEventListener('load', function () { armed = Date.now(); });
    return oSend.apply(this, arguments);
  };

  // Ouvre un drawer: 1) app Essential Cart Drawer (elle neutralise showModal du
  // theme et impose le sien) 2) drawer natif du theme. Si RIEN de visible apres
  // 1.2s -> fallback: navigation /cart (comportement d'origine, aucune cliente
  // bloquee sans feedback).
  var mmFallback = false;
  function drawerVisible() {
    var ec = document.querySelector('.essential-cart-drawer-container');
    var inner = ec && ec.firstElementChild;
    if (inner && inner.offsetWidth > 100 && getComputedStyle(inner).visibility === 'visible') return true;
    var dlg = document.querySelector('cart-drawer-component dialog');
    return !!(dlg && dlg.open);
  }
  var busy = false;
  function openDrawer() {
    if (busy) return; busy = true;
    try { if (window.essentialCartApi) { essentialCartApi.refreshCart(); essentialCartApi.openCart(); } } catch (e) {}
    try {
      var cd = document.querySelector('cart-drawer-component');
      if (cd) { cd.setAttribute('auto-open', ''); cd.open(); }
    } catch (e) {}
    setTimeout(function () {
      busy = false;
      if (!drawerVisible()) { mmFallback = true; window.location.href = '/cart'; return; }
      var btn = document.querySelector('.rapi-bb-checkout-btn');
      if (btn && /adding/i.test(btn.innerText)) { btn.innerText = 'Add Bundle to Cart'; }
    }, 1200);
  }

  // declencheur principal: la completion du XHR /cart/add.js du builder
  // (Rapi peut ou non tenter sa redirection ensuite; on la neutralise ci-dessous)
  var oSend2 = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__mmCartAdd) this.addEventListener('load', function () {
      if (this.status >= 200 && this.status < 300) setTimeout(openDrawer, 300);
    });
    return oSend2.apply(this, arguments);
  };

  if (window.navigation && navigation.addEventListener) {
    navigation.addEventListener('navigate', function (e) {
      try {
        var u = new URL(e.destination.url);
        if (u.origin === location.origin && u.pathname === '/cart' && !e.userInitiated &&
            !mmFallback && Date.now() - armed < 4000 && e.cancelable) {
          e.preventDefault();
          openDrawer();
        }
      } catch (_) {}
    });
  }
})();
